import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// import { DocumentListComponent } from 'app/modules/shared/components/document-list/document-list.component';
import { NoResultFoundComponent } from 'app/modules/shared/components/no-result-found/no-result-found.component';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { AppSettings } from '../../../shared/app.settings';
import { StatusComponent } from '../../../shared/components/status/status.component';
import type { Country } from '../../../shared/models/country';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../shared/services/entity.service';
import type { AttributeData } from '../../../shared/models/attribute.models';
// import { VehicleJourneyHistoryComponent } from '../vehicle-journey-history/vehicle-journey-history.component';
import { DeliveryDetailsComponent } from './delivery-details/delivery-details.component';
import { SiteOverviewDetailsComponent } from './overview-details/overview-details.component';
import { SiteProtocolsComponent } from './site-protocols/site-protocols.component';
import { SiteUsersComponent } from './site-users/site-users.component';
import { CardModule } from 'primeng/card';
import { ConfigService } from 'app/modules/shared/services/config.service';
// import { SpecificationComponent } from './specification/specification.component';
// import { VehicleAssignmentHistoryComponent } from './vehicle-assignment-history/vehicle-assignment-history.component';
// import { VehicleFeaturesComponent } from './vehicle-features/vehicle-features/vehicle-features.component';

interface SiteDetails {
  entityId: string;
  actionStatus: string;
  attributeCodeValueDtoList: Array<{
    attributeCode: string;
    attributeValue: string;
  }>;
  [key: string]: unknown;
}

interface EntityCount {
  [key: string]: unknown;
}

@Component({
  selector: 'app-site-details',
  standalone: true,
  imports: [
    BreadcrumbModule,
    StatusComponent,
    TabViewModule,
    TranslateModule,
    MenuModule,
    ToastModule,
    SiteOverviewDetailsComponent,
    ButtonModule,
    // SpecificationComponent,
    // VehicleAssignmentHistoryComponent,
    // DocumentListComponent,
    AccessProviderDirective,
    // VehicleJourneyHistoryComponent,
    NoResultFoundComponent,
    DeliveryDetailsComponent,
    SiteProtocolsComponent,
    SiteUsersComponent,
    CardModule,
    StatusComponent,


  ],
  templateUrl: './site-details.component.html',
  styleUrl: './site-details.component.scss'
})

export class SiteDetailsComponent implements OnInit {
  @Input() tableData: Record<string, unknown>[];
  routePath: MenuItem[] = [];
  siteId: string;
  userId: string = '';
  country: Country;
  activeIndex: number = 0;
  data: AttributeData;
  siteAttributeData: AttributeData;
  attributeLabels: Record<string, string> = {};
  siteAttributeLength: number;
  attributeValues: Record<string, unknown>[] = [];
  imgFileId: string;
  imgFileUrl: string;
  showStatus: boolean = true;
  vehicleEntityId: string;
  currentRow: Record<string, unknown>;
  siteDetails: SiteDetails;
  entityForStatus: { entityName: string; entityStatus: Record<string, unknown> };
  editBtnLabel: string;
  relatedData: unknown;
  driverList: Record<string, unknown>[] = [];
  defaultLoaderImg = AppSettings.DEFAULT_LOADER_IMAGE;
  entityCode: string = AppSettings.ENTITY_CODE.VEHICLE_DOCUMENT;
  isUnassigned: boolean = false;
  isDeleted: boolean = false;
  breadCrumbLabel: string;
  isSiteReady: boolean = false;
  entityCount: EntityCount;

  constructor(private route: ActivatedRoute,
    public cs: CommonBindingDataService,
    private cd: ChangeDetectorRef,
    private siteService: EntityService,
    private storageService: StorageService,
    private configService: ConfigService,
    private router: Router) {

  }

  ngOnInit() {
    this.editBtnLabel = this.cs.getLabel('lbl_edit');

    this.route.queryParams.subscribe(params => {
      this.siteId = params?.id;
      this.getEntityCount();
      switch (params?.tab) {
        case 'overview':
          this.breadCrumbLabel = this.cs.getLabel('site.lbl_overview');
          this.activeIndex = 0;
          break;
        case 'delivery-details':
          this.breadCrumbLabel = this.cs.getLabel('site.lbl_delivery_details');
          this.activeIndex = 1;
          break;
        case 'protocols':
          this.breadCrumbLabel = this.cs.getLabel('site.lbl_protocols');
          this.activeIndex = 2;
          break;
        case 'users':
          this.breadCrumbLabel = this.cs.getLabel('site.lbl_users');
          this.activeIndex = 3;
          break;
      }
      this.setRoutePath();
    });
    this.getAttributeData();
    this.siteService.entityCurrentRow.subscribe(res => {
      this.currentRow = res;
    });
  }

  setRoutePath() {
    this.routePath = [
      {
        label: this.cs.getLabel('site.lbl_site'),
        routerLink: '/app/sites',
        icon: 'pi pi-arrow-left',
        iconStyle: { 'font-weight': 'bold', 'margin-right': '10px' },
        command: () => {
          this.storageService.setItem('vehicleActiveIndex', 0);
          this.router.navigate['app/sites'];
        }
      },
      {
        label: this.breadCrumbLabel,
        // routerLink: '/app/sites/site-details/overview/' + this.siteId,
        styleClass: 'breadcrumb-child forward-slash breadcrumb-text',
        style: { 'display': 'flex', 'top': '2px', 'position': 'relative' }
      }
    ];
  }

  activeIndexChange(event) {
    this.activeIndex = event.index;
    switch (event) {
      case 0:
        this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'overview', id: this.siteId } });
        break;
      case 1:
        this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'delivery-details', id: this.siteId } });
        break;
      case 2:
        this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'protocols', id: this.siteId } });
        break;
      case 3:
        this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'users', id: this.siteId } });
        break;
    }
  }

  getAttributeData() {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.siteService.getAttributeDefinition(AppSettings.ENTITY_CODE.SITE, AppSettings.VIEW_CODE.DETAIL_VIEW).subscribe(res => {
      this.data = res;
      this.attributeLabels = this.cs.getAttributeLabels(this.data) as unknown as Record<string, string>;
      this.siteAttributeData = this.cs.getOrganizedAttribute(this.data);
      this.siteAttributeLength = this.siteAttributeData.tabs.length;
      this.getSiteDetails();
    })
  }

  getSiteDetails() {
    this.siteService.getEntity(this.siteId, AppSettings.ENTITY_CODE.SITE, AppSettings.VIEW_CODE.DETAIL_VIEW).subscribe((result: any) => {
      this.attributeValues = this.cs.getOrgAttributeValues(result);
      this.siteDetails = result;
      this.setStatusData();
    });
  }

  setStatusData() {
    const findAttributeValue = (attributeCode: string) =>
      this.siteDetails?.attributeCodeValueDtoList.find(ele => ele.attributeCode === attributeCode)?.attributeValue || this.cs.getLabel('lbl_empty');

    const statusObj = findAttributeValue('site_status');
    const siteCodeObj = { ID: findAttributeValue('site_code') };

    this.entityForStatus = {
      entityName: `${findAttributeValue('site_name')}`,
      entityStatus: { ...siteCodeObj, ...statusObj }
    };

    this.isSiteReady = true;
  }


  edit() {
    this.router.navigate([`app/sites/add-site/${this.siteDetails.entityId}`]);
  }

  getDeleted(): boolean {
    return this.siteDetails?.actionStatus === 'DELETED';
  }

  getUnassigned(): boolean {
    return this.siteDetails?.actionStatus === 'UNASSIGNED';
  }

  getEntityCount() {
    this.siteService.getEntityDashboardCount(AppSettings.ENTITY_CODE.SITE, this.siteId, false).subscribe((res: any) => {
      this.entityCount = res;
    })
  }

  onDeliverySaveSuccess() {
    this.getEntityCount();
  }

  onProtocolCountUpdate(count: number) {
    if (this.entityCount) {
      this.entityCount.protocol_count = count;
    }
  }

  onUserCountUpdate(count: number) {
    if (this.entityCount) {
      this.entityCount.user_count = count;
    }
  }

  navigateToProtocolTab() {
    this.activeIndex = 2;
    this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'protocols', id: this.siteId } });
  }

  navigateToUserTab() {
    this.activeIndex = 3;
    this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'users', id: this.siteId } });
  }

}
